
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import {readFormsFile, readToken} from '@/store/main/getters';
import {dispatchGetFormsFile} from '@/store/main/actions';
import pdf from 'vue-pdf';
import {api} from '@/helpers/api';


@Component({
  components: {pdf},
})
export default class PdfPreviewDialog extends Vue {
  @Prop()
  public pdfDataId!: number;
  @Prop()
  public formValueId?: number;

  private pageCount: any = 0;
  private currentPage: any = 0;
  private pdfLocalData: any = '';
  private errorMessage: string = '';

  private dialog: boolean = false;
  private imageType: string = '';

  private imageTypeValid: any = ['image/jpeg', 'image/png', 'image/jpg'];

  // public async mounted() {}

  @Watch('dialog')
  private async showPdfData() {
    if (this.dialog && this.pdfDataId > 0) {
      this.errorMessage = '';
      if (!this.pdfData) {
        await dispatchGetFormsFile(this.$store, this.pdfDataId);
      }
      await this.readFileAsURL(this.pdfData).then((result) => this.pdfLocalData = result);
    }
  }

  private get pdfData() {
    return readFormsFile(this.$store)(+this.pdfDataId);
  }



  private async readFileAsURL(file) {

    if (!file) {
      this.errorMessage = 'Arquivo indisponível. O vínculo aponta para um arquivo que não existe no banco.';
      return '';
    }
    try {
      const response = await api.downloadFormFile(readToken(this.$store), this.pdfDataId);
      this.imageType = this.imageTypeValid.find((e) => e === file.type) ? file.type : '';
      return URL.createObjectURL(response.data);
    } catch (e) {
      this.errorMessage = 'Arquivo indisponível. O registro existe, mas o conteúdo não foi encontrado.';
      return '';
    }
  }
}
